import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    // Extraer el estado del pago de los parámetros de URL
    const urlParams = new URLSearchParams(location.search);
    const status = urlParams.get('payment');
    const collection_status = urlParams.get('collection_status');
    const payment_id = urlParams.get('payment_id');
    const preference_id = urlParams.get('preference_id');
    
    // Determinar el estado basado en los parámetros
    let finalStatus = status;
    if (collection_status) {
      finalStatus = collection_status === 'approved' ? 'success' : 
                   collection_status === 'rejected' ? 'failure' : 'pending';
    }
    
    setPaymentStatus({
      status: finalStatus,
      payment_id,
      preference_id,
      collection_status
    });
  }, [location]);

  const getStatusInfo = () => {
    switch (paymentStatus?.status) {
      case 'success':
        return {
          icon: '✅',
          title: '¡Pago Exitoso!',
          message: 'Tu suscripción a Constructora Pro ha sido activada.',
          color: '#10B981',
          bgColor: '#ECFDF5',
          borderColor: '#A7F3D0',
          buttonText: 'Ir al Dashboard',
          buttonAction: () => navigate('/dashboard')
        };
      
      case 'pending':
        return {
          icon: '⏳',
          title: 'Pago Pendiente',
          message: 'Tu pago está siendo procesado. Te notificaremos cuando esté confirmado.',
          color: '#F59E0B',
          bgColor: '#FFFBEB',
          borderColor: '#FDE68A',
          buttonText: 'Volver al Inicio',
          buttonAction: () => navigate('/')
        };
      
      case 'failure':
        return {
          icon: '❌',
          title: 'Pago Rechazado',
          message: 'No se pudo procesar tu pago. Puedes intentar nuevamente.',
          color: '#EF4444',
          bgColor: '#FEF2F2',
          borderColor: '#FECACA',
          buttonText: 'Intentar Nuevamente',
          buttonAction: () => navigate('/payment')
        };
      
      default:
        return {
          icon: '🔄',
          title: 'Procesando...',
          message: 'Estamos verificando el estado de tu pago.',
          color: '#6B7280',
          bgColor: '#F9FAFB',
          borderColor: '#E5E7EB',
          buttonText: 'Esperar',
          buttonAction: () => {}
        };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div 
          className="bg-white rounded-xl shadow-lg p-8 text-center"
          style={{ 
            borderLeft: `4px solid ${statusInfo.borderColor}`,
            backgroundColor: statusInfo.bgColor 
          }}
        >
          {/* Icono grande */}
          <div 
            className="text-6xl mb-4"
            style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
          >
            {statusInfo.icon}
          </div>

          {/* Título */}
          <h1 
            className="text-2xl font-bold mb-4"
            style={{ color: statusInfo.color }}
          >
            {statusInfo.title}
          </h1>

          {/* Mensaje */}
          <p className="text-gray-700 mb-6 leading-relaxed">
            {statusInfo.message}
          </p>

          {/* Información del pago (si está disponible) */}
          {paymentStatus?.payment_id && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-sm">
              <div className="space-y-2">
                {paymentStatus.payment_id && (
                  <div className="flex justify-between">
                    <span className="font-medium">ID de Pago:</span>
                    <span className="font-mono text-xs">{paymentStatus.payment_id}</span>
                  </div>
                )}
                {paymentStatus.preference_id && (
                  <div className="flex justify-between">
                    <span className="font-medium">Preferencia:</span>
                    <span className="font-mono text-xs">{paymentStatus.preference_id.slice(0, 20)}...</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Botón de acción */}
          <button
            onClick={statusInfo.buttonAction}
            className="w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-200 hover:transform hover:scale-105"
            style={{ 
              backgroundColor: statusInfo.color,
              boxShadow: `0 4px 12px ${statusInfo.color}30`
            }}
          >
            {statusInfo.buttonText}
          </button>

          {/* Información adicional */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Plan: Constructora Pro • Trial 14 días gratis
            </p>
            {paymentStatus?.status === 'success' && (
              <p className="text-xs text-gray-500 mt-1">
                Próximo cobro: {new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString()}
              </p>
            )}
          </div>
        </div>

        {/* Enlaces adicionales */}
        <div className="mt-4 text-center space-x-4">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-gray-600 hover:text-gray-800 underline"
          >
            Volver al Inicio
          </button>
          <span className="text-gray-400">•</span>
          <button
            onClick={() => window.open('mailto:soporte@constructora.com')}
            className="text-sm text-gray-600 hover:text-gray-800 underline"
          >
            Contactar Soporte
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResult; 